import React from "react";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import "../styles/Footer.css";

function Footer() {
  return (
    <div className="footer my-5">
      <div className="socialMedia">
        <a href="https://www.linkedin.com/company/techcomb/" target="_blank">
        <LinkedInIcon />
        </a>
      </div>
      <p> &copy; 2025-2035 TechComb Inc.</p>
    </div>
  );
}

export default Footer;